
import initialize from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-form/actions/initialize';
import submit from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-form/actions/submit';
import toggleOtherAgency from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-form/actions/toggleOtherAgency';

export default {
    initialize,
    submit,
    toggleOtherAgency,
};